
















import { Component, Prop, Vue } from 'vue-property-decorator'
import AppMenu from '@/layout/AppMenu.vue'

@Component({
  components: {
    AppMenu
  }
})
export default class App extends Vue {
  @Prop() private msg!: string;

  get showExamples() {
    return location.hash.startsWith('#/examples')
  }
}
